import { render, staticRenderFns } from "./PaymentAccount.vue?vue&type=template&id=3396096f&lang=pug&"
import script from "./PaymentAccount.vue?vue&type=script&lang=ts&"
export * from "./PaymentAccount.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports